import * as React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "../AppLayout";
import HrDashboard from "@/Pages/HrDashboard";
import StudentList from "../StudentList";
import AddStudents from "../AddStudent";
import HrAttendance from "../AttendanceComponent";
import ViewFeesComponent from "../ViewFeesComponent";
import CourseCard from "../CourseCard";
import EnquiryManagement from "../EnquiryManagement";
import AttendanceTable from "../AttendanceTable";
import BatchCreationDialog from "../BatchCreationDialog";
import FeeHistory from "../FeeHistory";
import StudentProfile from "../StudentProfile";
import AttendanceHistory from "../AttendanceHistory";

export default function hrRoutes() {
  return (
    <Routes>
      {/* Layout Route */}
      <Route path="/" element={<AppLayout />}>
        {/* Nested Routes for HR Dashboard */}
        <Route index element={<HrDashboard />} />
        <Route path="attendance" element={<HrAttendance />} />
        <Route path="attendance/:id" element={<AttendanceTable />} />
        {/* <Route
          path="attendance/:id/attendancehistory"
          element={<AttendanceHistory />}
        /> */}
        <Route path="view-fee" element={<ViewFeesComponent />} />
        <Route path="feehistory/:id" element={<FeeHistory />} />
        <Route path="attendancehistory/:id" element={<AttendanceHistory />} />
        <Route path="courses" element={<CourseCard />} />
        {/* <Route path="courses/:courseName" element={<ViewStudents />} /> */}
        <Route path="courses/:coursename" element={<StudentList />} />
        <Route path="batch" element={<BatchCreationDialog />} />
        <Route path="enquiry" element={<EnquiryManagement />} />
        <Route path="students" element={<StudentList />} />
        <Route path="/:username" element={<StudentProfile />} />
        <Route path="student/add-student" element={<AddStudents />} />
        <Route path="students/update/:id" element={<AddStudents />} />
        <Route path="*" element={<h1>404 NOt Found</h1>} />
      </Route>
    </Routes>
  );
}
